// extracted by mini-css-extract-plugin
export default {"resultTextBlock":"KgHqq7SmK8BiKlw5kwmo","indicatorText":"VPYBP23JwNEXL1PseXtY"};